var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Crecord-display schema=\"{{$ctrl.schema}}\" mode=\"full\" record=\"$ctrl.record\"\u003E\u003C\u002Frecord-display\u003E";;return pug_html;};
module.exports = template;